import api from '../_api';

const actions = {
    getEvents: ({commit}) => {

        return new Promise((resolve, reject) => {
            commit('RESET_STATE');
            commit('ROSTER_LOADING');

            api.getEvents()
                .then((resp) => {
                    commit('EVENTS_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('ROSTER_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getRoster: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('ROSTER_LOADING');

            api.getRosterByCurrentUser(payload.sel_event, payload.roster_date)
                .then((resp) => {
                    commit('ROSTER_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('ROSTER_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    clearRosterErrors:({commit}) => {
        commit('CLEAR_ROSTER_ERRORS');
    },
}

export default actions
